import apiService from './api';
import { Stock } from '../types/stockTypes';

class StockService {
  async getStock(productId?: string): Promise<Stock[]> {
    const url = productId ? `/stocks?product_id=${productId}` : '/stocks';
    const response = await apiService.get<Stock[]>(url);
    return response.data;
  }
}

export const stockService = new StockService();
export default stockService;